import { useEffect, useRef, Suspense, lazy } from 'react';

import Container from '@mui/material/Container';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import ActivityIndicator from 'components/activityIndicator';
import Gtag from 'components/gtag';
import IframeScreen from 'screen/iframe';
import { SESSION_SCREEN, events } from 'utils/events';

const RequestQuote = lazy(() => import('screen/RequestQuote'));
const ReviewQuote = lazy(() => import('screen/ReviewQuote'));
const CustomerAndVehicles = lazy(
  () => import('./screen/customer-and-vehicles')
);
const Pickup = lazy(() => import('screen/Pickup'));
const Delivery = lazy(() => import('screen/Delivery'));
const Payment = lazy(() => import('screen/Payment'));
const OrderSuccess = lazy(() => import('screen/OrderSuccess'));
const PaymentFailure = lazy(() => import('screen/PaymentFailure'));
const OrderFailure = lazy(() => import('screen/OrderFailure'));

const resizeObserver = new ResizeObserver(events.updateHost);

const Router = () => {
  const appRef = useRef<HTMLDivElement>(null);
  const isDevelopment = process.env.NODE_ENV !== 'production';

  useEffect(() => {
    window.addEventListener('message', events.handleSessionMessage);

    const appDiv = appRef.current as HTMLDivElement;
    resizeObserver.observe(appDiv);

    return () => {
      window.removeEventListener('message', events.handleSessionMessage);
      resizeObserver.unobserve(appDiv);
    };
  }, []);

  return (
    <Container
      id="global-container"
      ref={appRef}
      maxWidth="md"
      style={{ padding: 0 }}
    >
      <BrowserRouter>
        <Suspense fallback={<ActivityIndicator />}>
          <Gtag />

          <Routes>
            <Route
              path={SESSION_SCREEN.REQUEST_QUOTE}
              element={<RequestQuote />}
            />
            <Route
              path={SESSION_SCREEN.SDK_REQUEST_QUOTE}
              element={<RequestQuote />}
            />
            <Route
              path={SESSION_SCREEN.SDK_BRAND_REQUEST_QUOTE}
              element={<RequestQuote />}
            />

            <Route
              path={SESSION_SCREEN.REVIEW_QUOTE}
              element={<ReviewQuote />}
            />
            <Route
              path={SESSION_SCREEN.SDK_REVIEW_QUOTE}
              element={<ReviewQuote />}
            />
            <Route
              path={SESSION_SCREEN.SDK_BRAND_REVIEW_QUOTE}
              element={<ReviewQuote />}
            />

            <Route
              path={SESSION_SCREEN.SDK_SUMMARY}
              element={<ReviewQuote />}
            />
            <Route
              path={SESSION_SCREEN.SDK_BRAND_SUMMARY}
              element={<ReviewQuote />}
            />

            <Route
              path={SESSION_SCREEN.CUSTOMER_AND_VEHICLE_INFO}
              element={<CustomerAndVehicles />}
            />
            <Route path={SESSION_SCREEN.PICKUP_INFO} element={<Pickup />} />
            <Route path={SESSION_SCREEN.DELIVERY_INFO} element={<Delivery />} />
            <Route path={SESSION_SCREEN.PAYMENT_INFO} element={<Payment />} />
            <Route
              path={SESSION_SCREEN.PAYMENT_FAILURE}
              element={<PaymentFailure />}
            />
            <Route
              path={SESSION_SCREEN.ORDER_SUCCESS}
              element={<OrderSuccess />}
            />
            <Route
              path={SESSION_SCREEN.PAYMENT_SUCCESS}
              element={<OrderSuccess />}
            />
            <Route
              path={SESSION_SCREEN.ORDER_FAILURE}
              element={<OrderFailure />}
            />

            {isDevelopment && (
              <Route path="iframe" element={<IframeScreen />} />
            )}
          </Routes>
        </Suspense>
      </BrowserRouter>
    </Container>
  );
};

export default Router;
